import type {Logger} from 'src/typings';
import type {CurrentAuthService} from 'shared/services';
import type {ActiveSessionsPageData, LoggerLevel, UtilPageData} from '../types';
import type {LoggerDataService} from './logger.data-service';
import type {ServerStateDataService} from './server-state.data-service';
import type {UtilsDataService} from './utils.data-service';

export class KpUtilService {
    public static serviceName = 'kpUtilService';

    /*@ngInject*/
    constructor(private serverStateDataService: ServerStateDataService,
                private utilsDataService: UtilsDataService,
                private loggerDataService: LoggerDataService,
                private currentAuthService: CurrentAuthService) {
    }

    public async getUtilPageData(): Promise<UtilPageData> {
        const portaroStatePromise = this.serverStateDataService.getServerState();
        const loggersPromise = this.loggerDataService.getLoggers();

        // Resolve everything in parallel
        const [portaroState, loggers] = await Promise.all([
            portaroStatePromise,
            loggersPromise
        ]);

        return {
            portaroState,
            loggers
        };
    }

    public async getActiveSessionsPageData(): Promise<ActiveSessionsPageData> {
        return {
            activeClientSessions: await this.utilsDataService.getActiveClientSessionsList()
        };
    }

    public async saveLoggerLevel(logger: Logger, newLoggerLevel: LoggerLevel) {
        await this.loggerDataService.changeLevel(logger.id, newLoggerLevel);
    }

    public get isAdministrator(): boolean {
        return this.currentAuthService.hasRole('ROLE_ADMIN');
    }
}